<template>
    <div>
        <div class="page_header">
            <span class="page_title">{{ $t('menuLog.page_title') }}</span>
            <el-form  :inline="true" :size="size" style="flex:1;text-align: right;">
                <el-form-item :label="$t('time.timeQuery')">
                    <el-date-picker v-model="date" type="daterange" align="right" style="width: 280px;"
                        :range-separator="$t('time.to')" :picker-options="datePickerOptions"
                        :start-placeholder="$t('time.startDate')" :end-placeholder="$t('time.endDate')">
                    </el-date-picker>
                </el-form-item>
                <el-form-item :label="$t('operlogq.menu') + '：'">
                    <el-select v-model="form.MenuID" :placeholder="$t('operlogq.please_menu')" style="width: 120px;">
                        <el-option :label="$t('public.all')" :value="-1"></el-option>
                        <template v-for="item in menus">
                            <el-option v-for="i in item.children" :key="i.MenuID" :label="i.title"
                                :value="i.MenuID"></el-option>
                        </template>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('operlogq.opt_name') + '：'">
                    <el-input clearable v-model="form.OperatorName" style="width: 180px;"
                        :placeholder="$t('operlogq.please_opt_name')"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">{{ $t("public.query") }}</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="page_container">
            <el-table v-loading="loading" :size="size" :data="tableData" border style="width: 100%">
                <el-table-column prop="ID" align="center" width="60" :label="$t('public.index')"> </el-table-column>
                <el-table-column prop="OperatorName" align="center" :label="$t('operlogq.OperatorName')">
                </el-table-column>
                <el-table-column prop="LoginName" align="center" :label="$t('operlogq.LoginName')">
                </el-table-column>
                <el-table-column prop="FuncName" align="center" :label="$t('operlogq.FuncName')">
                </el-table-column>
                <el-table-column prop="AccessTime" align="center" :label="$t('operlogq.AccessTime')">
                </el-table-column>
                <el-table-column prop="InTime" align="center" :label="$t('operlogq.InTime')">
                </el-table-column>
                <el-table-column prop="OutTime" align="center" :label="$t('operlogq.OutTime')">
                </el-table-column>
                <el-table-column prop="LoginIP" align="center" :label="$t('operlogq.LoginIP')">
                </el-table-column>
            </el-table>

            <kl-pagination style="margin-bottom: 10px;" :total="total" @current-change="pageChange"
                :current-page.sync="form.PageNo">
            </kl-pagination>

        </div>
    </div>
</template>

<script>

export default {
    name: "operlogq",
    data() {
        return {
            date: [],
            loading: false,
            form: {
                OperatorID: 0,
                BeginTime: "",
                EndTime: "",
                MenuID: -1,
                OperatorName: '',
                PageNo: 1,
                PageSize: 10
            },
            tableData: [],
            total: 0,
            datePickerOptions: {
                disabledDate(date) {
                    return date > new Date(new Date().getTime())
                }
            },
        }
    },
    computed: {
        size() {
            return this.$store.getters.size
        },
        operator() {
            return this.$store.getters.operator
        },
        menus() {
            return this.$store.getters.menus
        }
    }, methods: {
        pageChange(page) {
            this.form.PageNo = page;
            this.queryList();
        },
        init() {
            //初始化查询条件
            //查询日期，最近7天

            var now = this.moment();//今天
            var prev = this.moment().subtract(7, 'days');//7天前
            // console.log(now)
            // console.log(prev)
            this.date = [prev, now];

            this.form.OperatorID = this.operator.OperatorId;

        },
        queryList() {
            this.loading = true;
            this.$api.queryOperatorLogList(this.form).then(res => {
                this.loading = false;
                if (res && res.code == 200) {
                    this.tableData = res.data.data;
                    this.total = res.data.recordsTotal
                }

            }).catch(() => {
                this.loading = false;
            });
        },
        onSubmit() {
            //整理查询字段

            this.form.BeginTime = this.moment(this.date[0]).format('YYYY-MM-DD 00:00:00')
            this.form.EndTime = this.moment(this.date[1]).format('YYYY-MM-DD 23:59:59')
            this.form.PageNo = 1;

            this.queryList();
        }

    }, mounted() {
        this.init();
        this.onSubmit();
    }
}
</script>
<style scoped lang="scss"></style>